import { HotelsMock } from "../interfaces/hotel.interface";

export const HotelsMockData: HotelsMock = {
    hotels: [
      {
        code: 6944,
        name: "Azuline Palmanova Gardens",
        starsRating: "3EST",
        destinationName: "Majorca",
        rooms: [
          {
            apartmentDescription: "1 BEDROOM",
            rates: [
              {
                price: "305.64",
                paymentType: "AT_WEB",
                rateKey:
                  "20230615|20230616|W|1|6944|APT.ST|CG-BAR SC|SC||2~1~2|8~10|N@06~~240169~-936315760~N~~~NOR~F3505849AD44415168322192053200AAUK00000010000000010240131",
                rateType: "BOOKABLE",
                allotment: 3,
                cancellationPolicy: {
                  amount: "305.64",
                  from: "2023-06-12T23:59:00+02:00",
                },
                taxes: {
                  amount: "4.40",
                  included: false,
                },
              },
            ],
          },
        ],
        rateRange: {
          minRate: "305.64",
          maxRate: "305.64",
        },
        currency: "EUR",
        description:
          "The hotel is located in a quiet residential area of ​​Palmanova, ideal to rest and enjoy an unforgettable holiday in Mallorca...",
        address: {
          country: "Spain",
          street: "Costa Llobera",
          buildingNumber: "15",
          city: "PALMANOVA",
          postalCode: "07181",
        },
        contactDetails: {
          email: "RESERVAS.PALMANOVA@AZULINEHOTELS.COM",
          phones: [
            {
              phoneNumber: "+971346813",
              phoneType: "PHONEBOOKING",
            },
            {
              phoneNumber: "+971682408",
              phoneType: "PHONEHOTEL",
            },
          ],
        },
        images: [
          {
            url: "http://photos.hotelbeds.com/giata/00/006944/006944a_hb_r_001.jpg",
            imgFacilityType: "Restaurant",
            code: "RES",
          },
          // Add other image objects...
        ],
        accommodationTypeCode: "H",
        lastUpdate: "2023-01-23",
      },
      // Add other hotel objects...
    ],
    metadata: {
      checkIn: "2023-06-15",
      checkOut: "2023-06-16",
      language: "ENG",
      occupancies: {
        rooms: 2,
        adults: 1,
        children: 2,
        paxes: [
          {
            type: "CH",
            age: 8,
          },
          {
            type: "CH",
            age: 10,
          },
        ],
      },
      city: "London",
    },
  };